import { render } from "./ApplicationMark.vue?vue&type=template&id=be597ebc"
const script = {}

import exportComponent from "/var/www/webcrm-develop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__